import React from 'react';
import { TicketStatus } from '@bisa/shared';

interface BadgeProps {
  children: React.ReactNode;
  color?: 'gray' | 'blue' | 'green' | 'yellow' | 'red' | 'purple' | 'orange';
}

const colorClasses: Record<NonNullable<BadgeProps['color']>, string> = {
  gray: 'bg-gray-100 text-gray-700',
  blue: 'bg-blue-100 text-blue-700',
  green: 'bg-green-100 text-green-700',
  yellow: 'bg-yellow-100 text-yellow-800',
  red: 'bg-red-100 text-red-700',
  purple: 'bg-purple-100 text-purple-700',
  orange: 'bg-orange-100 text-orange-700',
};

export function Badge({ children, color = 'gray' }: BadgeProps) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${colorClasses[color]}`}>
      {children}
    </span>
  );
}

const statusColors: Record<TicketStatus, BadgeProps['color']> = {
  [TicketStatus.WAITING]: 'blue',
  [TicketStatus.CALLED]: 'orange',
  [TicketStatus.SERVED]: 'green',
  [TicketStatus.EXPIRED]: 'gray',
  [TicketStatus.NO_SHOW]: 'red',
  [TicketStatus.CANCELLED]: 'gray',
  [TicketStatus.SKIPPED]: 'yellow',
};

export function TicketStatusBadge({ status }: { status: TicketStatus }) {
  return <Badge color={statusColors[status]}>{status}</Badge>;
}
